export const SELECT_ASSET = 'SELECT_ASSET';
export const CLEAR_SELECTED_ASSET = 'CLEAR_SELECTED_ASSET';

export const selectAsset = (selectedAsset) => ({ type: SELECT_ASSET, selectedAsset });

export const clearSelectedAsset = () => ({ type: CLEAR_SELECTED_ASSET });
